import apiClient from "../../../services/apiClient";


export async function getTimeLine(id){
    
    const url = `visitskg/freeslots?kg_id=${id}`;

    const result = await apiClient.get(url);

    return result.data || null;

}

export async function getMyVisits(id){
    const url = `visitskg/my?kg_id=${id}`;

    const result = await apiClient.get(url);

    return result.data || null;

}

export async function saveDate(data) {
     
     const url = 'visitskg/visit';
     
     const result = await apiClient.post(url, data);

     return result.data || null;

}

export async function delDate(data) {
    const url = 'visitskg/my';

    const result = await apiClient.delete(url, data);

    return result.data || null;

}

export async function getKgInfo(){
    
    const url = 'kgs_info';

    const result = await apiClient.get(url);

    return result.data || null;
}

export async function getMyVisitsAll(){
    const url = `visits/myall`;

    const result = await apiClient.get(url);

    return result.data || null;

}


export const DAYS_UK = ['неділя', 'понеділок', 'вівторок', 'середа', 'четвер', "п'ятниця", 'субота'];


export const fmtDateTime = (iso) => {
    if (!iso) return '—';

    const dateI = new Date(iso);

    const [date, time] = iso.split("T");
    const [yyyy, month, dd] = date.split("-");
    const [hh,mm] = time.split(":");
    const day = dateI.getDay();

    return `${dd}.${month}.${yyyy} ${hh}:${mm} ${DAYS_UK[day]}`;
}
